import React from 'react';
import styles from './subhomeTabs.module.css';

const SubhomeTabs = ({ children }) => <div className={styles._tabs_wrapper}>{children}</div>;

export default SubhomeTabs;
